/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Export_Event_RelatedInputs */



/**
* | output |
* | --- |
* | "Event Related" |
*
* @param {Manual_Qc_Export_Event_RelatedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_export_event_related = /** @type {((inputs?: Manual_Qc_Export_Event_RelatedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Export_Event_RelatedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Lie a un evenement")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ereignisbezogen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Evento correlato")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Событие, связанное с")
	if (locale === "es") return /** @type {LocalizedString} */ ("Relacionado con el evento")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("事件相关")
	if (locale === "ja") return /** @type {LocalizedString} */ ("イベント関連")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्यक्रम से संबंधित")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Evento relacionado")
	return /** @type {LocalizedString} */ ("Event Related")
});